<template>
  <div class="slidebar">
    <div
      class="menu-mode"
      :class="`menu-mode-${m.mode || 'normal'}`"
      v-for="(m, idx) of menus"
      :key="idx"
    >
      <h4
        v-if="m.title"
        class="section-title selection-title-left-line"
      >{{ m.title }}</h4>
      <div class="menu">
        <p
          v-for="i of m.children"
          :key="i.value"
          class="menu-item"
          :class="{ 'active': activeMenu.some(val => val === i.value) }"
          @click="handleMenuClick(i, m, idx)"
        >{{ i.label }}</p>
      </div>
    </div>
    <div
      class="email-area"
      v-if="showEmail"
    >
      <a
        href="https://mp.weixin.qq.com/s?__biz=MzU3OTIyNTMzNA==&mid=2247484360&idx=1&sn=154f8ea60a35d5a834dbf57e9d3d4ef1&chksm=fd681051ca1f994771a5ac51869b076230bf9f631f9e2d1176828df1b988f1c84e8bf714f01b&mpshare=1&scene=1&srcid=1224oNSBFF6RwVVwIIkQUUzh&key=1b8c4255fb62ce5656aa13d374c1d4db03fa6adf3962f8766e1192d970b7916f4c7c662ea192075eb66481e1a6e91f50db06009a0a6adafc7944b8f094d7b2d70d3190053d91e4fefeed2783d9201187&ascene=0&uin=ODkxMDM2NTQx&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.3+build(16D30)&version=12020110&nettype=WIFI&lang=zh_CN&fontScale=100&pass_ticket=MOjxduragux%2BUpngBGtDjObfPyMb0pIv0TH7Wo0wOS3gvyfeZXfGDQ55eOlM%2BgIA"
        target="_block"
      >
        <img
          src="~@/assets/images/email_show.png"
          alt="心晴门诊免费邮箱咨询"
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'component-sidebar',
  props: {
    title: String,
    active: [String, Array],
    menus: { type: Array, required: true },
    showEmail: { type: Boolean, default: false }
  },
  data() {
    return {
      activeMenu: []
    }
  },
  watch: {
    active(val) {
      if (val) this.activeMenu = Array.isArray(val) ? val : [val]
    }
  },
  methods: {
    initActiveMenu() {
      const pathName = this.$route.name
      const allMenus = this.menus.reduce((a, b) => a.concat(b.children), [])
      const hit = allMenus.find(i => i.route === pathName)

      if (hit) {
        this.activeMenu = [hit.value]
      } else {
        this.activeMenu = Array.isArray(this.active)
          ? this.active
          : [this.active]
      }
    },
    handleMenuClick(child, parent, idx) {
      if (child.route) {
        this.$router.push({ name: child.route })
      }
      this.$set(this.activeMenu, idx, child.value)
      if (this.activeMenu.length > 1) {
        this.$emit('change', this.activeMenu)
      } else {
        this.$emit('change', this.activeMenu[0])
      }
    }
  },
  mounted() {
    this.initActiveMenu()
  }
}
</script>

<style lang='less' scoped>
@import '~variables.less';
@slidebar-width: 250px;

.slidebar {
  width: @slidebar-width;
  padding-top: @gutter;
  background-color: @bg-gray;

  .menu-mode {
    margin-bottom: @gutter * 2;
    padding-left: 80px;
  }

  .menu-item {
    // font-weight: bold;
    margin: @gutter / 2 0;
    cursor: pointer;
    &.active {
      color: @color-primary;
    }
  }

  .menu-mode-select {
    line-height: 1.4;
    .menu-item {
      &.active {
        position: relative;
        display: inline-block;
        font-size: 18px;
        font-weight: bold;
        color: #444;
        &::after {
          content: '';
          position: absolute;
          left: -8px;
          top: 1px;
          height: 22px;
          width: 4px;
          border-radius: 4px;
          background-color: @color-primary;
        }
      }
    }
  }

  .email-area {
    margin: @gutter * 2 @gutter / 2 @gutter;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue